<template>
  <div
    v-if="canShowWarning"
    style="align-items: center"
    class="seats-increase-warning-box dialog-warning blue"
  >
    <i class="d-flex hi hi-info-filled hi-12 text-blue" />

    <div>
      {{ warning }}
      <a
        class="text-nowrap"
        href="https://support.hubstaff.com/per-seat-pricing/"
      >
        Learn more
      </a>
    </div>
  </div>
</template>

<script>
import { pluralize } from '~/utils/string_utils';

export default {
  name: 'SeatsIncreaseWarning',
  props: {
    seatsMembersCount: {
      type: Number,
      required: true,
    },
    chargedMembersCount: {
      type: Number,
      required: true,
    },
    organization: {
      type: Object,
      required: true,
    },
  },
  computed: {
    warning() {
      if (this.availableSeats <= 0) {
        return 'Adding members will increase the number of paid seats on your plan as all seats are currently occupied.';
      }

      return `You have ${this.availableSeats} open ${pluralize(
        this.availableSeats,
        'seat',
        'seats',
      )}. Adding more than ${this.availableSeats} ${pluralize(
        this.availableSeats,
        'member',
        'members',
      )} will increase the number of paid seats on your plan.${
        this.isMonthlyPlan
          ? " New seats are charged for the entire month no matter when they're added within the billing period."
          : ''
      }`;
    },
    availableSeats() {
      return this.seatsMembersCount - this.chargedMembersCount;
    },
    canShowWarning() {
      return this.organization.show_per_seat_ui;
    },
    isMonthlyPlan() {
      return this.organization.plan_period === 'monthly';
    },
  },
};
</script>
